import { formatDate } from '@/lib/format-date'

interface DateFieldProps {
  label: string
  value: string
  onChange: (iso: string) => void
  required?: boolean
  disabled?: boolean
  /** Hide the DD MMM YY hint under the input (dense panes). */
  compact?: boolean
  id?: string
  className?: string
}

/** Native date input with DD MMM YY readout (UI-007). */
export function DateField({
  label,
  value,
  onChange,
  required,
  disabled,
  compact,
  id,
  className = '',
}: DateFieldProps) {
  return (
    <label className={`field ${className}`.trim()}>
      <span className="field__label">{label}</span>
      <input
        id={id}
        className="field__input"
        type="date"
        required={required}
        disabled={disabled}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      {!compact && value ? <span className="field__hint">{formatDate(value)}</span> : null}
    </label>
  )
}
